import { render, staticRenderFns } from "./AlterarMunicipio.vue?vue&type=template&id=04767707&scoped=true"
import script from "./AlterarMunicipio.vue?vue&type=script&lang=js"
export * from "./AlterarMunicipio.vue?vue&type=script&lang=js"
import style0 from "./AlterarMunicipio.vue?vue&type=style&index=0&id=04767707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04767707",
  null
  
)

export default component.exports